<template>
  <div class="min-h-screen flex flex-col">
    <main class="pt-0 pb-0 flex-grow bg-gray-100">
      <div class="w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div class="sm:max-w-full md:max-w-4xl lg:max-w-6xl xl:max-w-7xl mx-auto">

          <router-view />

        </div>
      </div>
    </main>
    <footer class="bg-gray-200 py-4">
      <p class="text-center">© 2024 EasyMarks AI</p>
    </footer>
  </div>
</template>
// eslint-disable-next-line vue/no-unused-components
<script setup lang="ts">
</script>
